import React from "react";
import { Board } from "./components/Board";

const App = () => {
  return (
    <div className="game-wrapper">
      <Board />
    </div>
  );
};

export default App;
